// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"151":"62b0a1fd","745":"62b0a1fd"}[chunkId] + ".chunk.css";
};